import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { CourseResponseType, Data } from "../types/courseResponse";
import { CoursePayloadType } from "../types/courseRequest";

export const courseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCourses: builder.query<
      ApiResponseType<Data>,
      { size?: number; search?: string; page?: number; published?: boolean }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.published)
          queryParams.append("published", params.published.toString());

        return `courses/get-all?${queryParams.toString()}`;
      },
      providesTags: ["Courses"],
    }),
    addCourse: builder.mutation<
      ApiResponseType<{ course: CourseResponseType }>,
      CoursePayloadType
    >({
      query: (payload) => ({
        url: "courses/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Courses"],
    }),
    getCourseById: builder.query<
      ApiResponseType<{ course: CourseResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `courses/get/${id}`,
      providesTags: ["Courses"],
    }),
    updateCourse: builder.mutation<
      ApiResponseType<{ course: CourseResponseType }>,
      { id: string; payload: CoursePayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `courses/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Courses"],
    }),
    deleteCourse: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `courses/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Courses"],
    }),
  }),
});

export const {
  useGetAllCoursesQuery,
  useAddCourseMutation,
  useGetCourseByIdQuery,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
} = courseApi;
